import * as React from 'react';

type UseImageDownloadButtonParams = {
    onDownloadImage: (imageId: number) => Promise<void>;
    currentImageId: number;
};

type UseImageDownloadButtonResult = {
    isDownloading: boolean;
    handleDownload: () => void;
};

export function useImageDownloadButton({
    onDownloadImage,
    currentImageId
}: UseImageDownloadButtonParams): UseImageDownloadButtonResult {
    let [isDownloading, setIsDownloading] = React.useState(false);

    function handleDownload() {
        if (typeof onDownloadImage === 'function') {
            setIsDownloading(true);
            onDownloadImage(currentImageId).then(() => {
                setIsDownloading(false);
            });
        }
    }

    return { isDownloading, handleDownload };
}
